import { type PropsWithChildren } from "react";

const MathJaxContext = (props: PropsWithChildren) => {
  const { children } = props;
  return children;
};

export default MathJaxContext;
